/// <reference path="./App.ts" />
namespace HA.Core.Entity {

    export class Menu extends App {

        public clear() {
            this.getMenu().clear();
        }

        public addItem(data: Map<string, any>) {
            this.getMenu().addItem(data);
        }

        protected getMenu(): HA.Core.Controller.HTML.AppMenu {
            return this.get("menu");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            const d = toMap(data);
            d.set("navigable", false);
            super.initialize(d);
            this.addToData("menu", new HA.Core.Controller.HTML.AppMenu(d));
        }

        protected createTag() {
            return;
        }
    }
}
